<template src="./template.html"></template>

<script>
export default {
  name: "HomeArtStory",
  data() {
    return {}
  },
  methods: {}
}
</script>